import { ReactNode, memo } from 'react';
import type { CSS } from '@stitches/react';
import { Component } from './Spacer.styles';

function SpacerPureComponent({ size }: { size: CSS['paddingTop'] }) {
  return <Component css={{ paddingTop: size, paddingLeft: size }} />;
}

export const Spacer = memo(SpacerPureComponent);
